"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EngagementTypes = _interopRequireDefault(require("customer-data-objects/engagement/EngagementTypes"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _default = _propTypes.default.oneOf(Object.keys(_EngagementTypes.default));

exports.default = _default;
module.exports = exports.default;